module.exports = __webpack_public_path__ + "static/img/1.0d3b5b98.png";